import type { FC, ReactNode } from "react";

import { Text } from "./Text";

interface EyebrowLabelProps {
  children: ReactNode;
  className?: string;
}

export const EyebrowLabel: FC<EyebrowLabelProps> = ({
  children,
  className = "",
}) => (
  <Text variant="label" className={`mr-2 ${className}`}>
    {children}
  </Text>
);
